import { MonitorArrowDownIcon } from './MonitorArrowDownIcon';

/**
 * author: Michael Irigoyen
 * id 8C772F38-CA90-4CAD-BC26-DE68A84FD6F4
 * name monitor-arrow-down
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-arrow-down.svg
 * tags
 * - Device / Tech 
 */
export const MonitorDownloadIcon = MonitorArrowDownIcon;
export default MonitorDownloadIcon